export class RecurringFrequency {
  FrequencyType : FrequencyRepeatTypes = FrequencyRepeatTypes.Weekly;
  EndType: FrequencyEndType = FrequencyEndType.Count;
  Count: number = 2;
  Until: Date;
  Interval: number = 2;
  ByDay: string;
  ByDayArray: any[];
  ByMonth: number;
  ByMonthDay: number;
  BySetPos: number = 1;
  DayType: string = "day";
}

export enum FrequencyEndType {
  Never = 1,
  Until = 2,
  Count = 3,
}

export enum FrequencyRepeatTypes {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4,
}
